import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculer la densité de l'eau - Calculatrice de densité de l'eau";
const DESCRIPTION =
  "Calculer la densité de l'eau - Calculatrice de densité de l'eau. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "water density calculator, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/water-density-calculator/";

function WaterDensityCalculator() {
  const [mass, setMass] = useState(0);
  const [volume, setVolume] = useState(0);
  const [result, setResult] = useState();
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      if (mass && volume) {
        const density = parseFloat(mass) / parseFloat(volume);
        setResult(density);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice calcule la densité de l'eau ou de toute autre substance en utilisant l'équation suivante:
                </p>
                <p>
                  <strong>Densité = Masse du matériau / Volume du matériau</strong>
                </p>
                <ul>
                  <li>
                    Entrez la masse du matériau et son volume pour calculer la densité en gramme/cm3 ou kg/m3.
                  </li>
                  <li>
                    La densité de l'eau à 4 degrés Celsius équivaut à 1 gramme/cm3 ou 1000 kg/m3.
                  </li>
                </ul>
                <p>
                  Cette calculatrice a été développée pour faciliter le processus de calcul de la densité et pour comprendre la relation entre la masse et le volume de tout matériau.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="mass">
                      <label className="form-label ms-2">
                        Entrez la masse du matériau (gramme)
                      </label>
                      <input
                        id="mass"
                        type="number"
                        value={mass}
                        onChange={(e) => setMass(e.target.value)}
                        placeholder="Entrez la masse du matériau"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="volume">
                      <label className="form-label ms-2">
                        Entrez le volume du matériau (cm3)
                      </label>
                      <input
                        id="volume"
                        type="number"
                        value={volume}
                        onChange={(e) => setVolume(e.target.value)}
                        placeholder="Entrez le volume du matériau"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">Résultat:</h4>
                      <p className="text-white">{result} gramme/cm3</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4 style={{ color: "black" }}>Étapes de la solution:</h4>
                        <ol>
                          <li>
                            Calculez la densité en utilisant l'équation: Densité = Masse / Volume
                          </li>
                          <li>
                            Densité = {mass} gramme / {volume} cm3 = {result}{" "}
                            gramme/cm3
                          </li>
                        </ol>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}

export default WaterDensityCalculator;
